import Element from '../../../Prototype/UI/Element';
import {IGameState} from "../../../State/Game/IGameState";
import SideMenuHandler from '../Menu/SideMenuHandler';

export default abstract class SectionBaseHandler {
    public section: Element;
    protected parent: SideMenuHandler;

    constructor(parent: SideMenuHandler) {
        this.parent = parent;
        this.onCreate();
    }

    public destroy(): void {
        this.onDestroy();

        if (this.section) {
            this.section.destroy();
            this.section = null;
        }
    }

    public abstract handleStateChanged(state: IGameState): void;

    protected abstract onCreate(): void;

    protected abstract onDestroy(): void;
}
